import styled from 'styled-components';

import Grid from '@mui/material/GridLegacy';

export const FieldDescription = styled.p`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 500;
  margin: 16px 0 5px;
`;

export const RequiredAsterisk = styled.span`
  color: ${({ theme }) => theme.palette.error.main};
  margin-left: 2px;
`;

export const SectionGrid = styled(Grid)`
  align-items: center;
  padding-bottom: 0;
  padding-top: 0;
`;
